import React, { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

const Products = () => {
  const container = useRef();

  useGSAP(() => {
    gsap.from(".product-card", {
      y: 100,
      opacity: 0,
      duration: 0.6,
      stagger: 0.1,
      ease: "power2.out",
      scrollTrigger: {
        trigger: container.current,
        start: "top 80%",
        toggleActions: "play none none reverse"
      }
    });

    // Special parallax for the shoe
    gsap.to(".shoe-img", {
      y: -50,
      rotate: -15,
      scrollTrigger: {
        trigger: ".shoe-container",
        start: "top 80%",
        end: "bottom 20%",
        scrub: true
      }
    });
  }, { scope: container });

  return (
    <div id="features" ref={container} className="lg:p-20 p-5 bg-slate-900/30 overflow-hidden">
      <div className="flex flex-col md:flex-row lg:gap-8 gap-5 justify-center items-center">
        <div className="product-card bg-[#1e293b] md:w-[45%] w-full lg:px-10 px-5 text-center lg:h-[600px] h-64 flex flex-col justify-between relative lg:rounded-[3rem] rounded-2xl border border-white/5 overflow-hidden group">
          <h1 className="lg:text-3xl text-xl lg:mt-12 mt-6 font-bold tracking-tight">
            AI <br /> Outfits
          </h1>
          <div className="shoe-container bg-gradient-to-b from-[#ec9294] to-[#d946ef] rounded-t-[2rem] lg:h-[50%] h-[35%] w-full relative">
            <img
              src="/red-shoe.png"
              alt="red-shoe"
              className="shoe-img lg:w-72 w-32 absolute left-1/2 -translate-x-1/2 lg:top-[-60px] top-[-30px] drop-shadow-[0_35px_35px_rgba(0,0,0,0.5)] transition-transform duration-500 group-hover:scale-110"
            />
          </div>
        </div>
        <div className="product-card bg-[#1e293b] md:w-[55%] w-full lg:h-[600px] h-64 text-center lg:px-10 px-5 flex flex-col justify-between lg:rounded-[3rem] rounded-2xl border border-white/5 overflow-hidden group">
          <h1 className="lg:text-3xl text-xl lg:mt-12 mt-6 font-bold tracking-tight">
            Realistic AI
            <br /> Avatar
          </h1>
          <div className="h-[65%] w-full overflow-hidden">
            <img
              src="/Avatar-ai.png"
              className="h-full w-full object-cover transition-transform duration-1000 group-hover:scale-110"
              alt="AI Avatar"
            />
          </div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row lg:gap-8 gap-5 justify-center lg:mt-8 mt-5 items-center">
        <div className="product-card bg-[#1e293b] md:w-[55%] w-full text-center lg:h-[600px] h-64 lg:px-10 px-5 flex flex-col justify-between lg:rounded-[3rem] rounded-2xl border border-white/5 overflow-hidden group">
          <h1 className="lg:text-3xl text-xl lg:mt-12 mt-6 font-bold tracking-tight">
            Generate or write your <br /> Script
          </h1>
          <div className="bg-gradient-to-tr from-indigo-500 to-purple-600 h-[60%] w-full opacity-80 group-hover:opacity-100 transition-opacity" />
        </div>
        <div className="product-card bg-[#1e293b] md:w-[45%] w-full lg:h-[600px] h-64 text-center lg:px-10 px-5 flex flex-col justify-between lg:rounded-[3rem] rounded-2xl border border-white/5 overflow-hidden group">
          <h1 className="lg:text-3xl text-xl lg:mt-12 mt-6 font-bold tracking-tight">
            AI Powered Voice <br /> Generator
          </h1>
          <div className="h-[65%] w-full overflow-hidden">
            <img
              src="/Avatar-ai.png"
              className="h-full w-full object-cover transition-transform duration-1000 group-hover:scale-110"
              alt="Voice Generator"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
